import { render, staticRenderFns } from "./EinstellungenPraesenz.vue?vue&type=template&id=253507a6&"
import script from "./EinstellungenPraesenz.vue?vue&type=script&lang=js&"
export * from "./EinstellungenPraesenz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports